import { ColumnDef } from '@tanstack/react-table';
import i18n from 'i18next';

import { SimpleProgressBar } from '@/components/common';
import { Tag } from '@/components/generic';
import { Organization, OrganizationSettings, TableData } from '@/types';

import { formatOptionalDate } from './date';

export const getOrganizationsColumns: () => ColumnDef<TableData>[] = () => [
  {
    id: 'name',
    accessorKey: 'name',
    header: i18n.t('name', { ns: 'common' })
  },
  {
    id: 'noOfCeremonies',
    accessorKey: 'organizationSettings',
    header: i18n.t('noOfCeremonies', { ns: 'common' }),
    cell: (props) => {
      const settings = props.getValue() as OrganizationSettings;
      if (!settings || !settings.ceremoniesPerInterval || settings.ceremoniesPerInterval === 0) {
        return null;
      }
      return (
        <SimpleProgressBar
          value={settings.currentCeremoniesCount ?? 0}
          max={settings.ceremoniesPerInterval ?? 0}
        />
      );
    }
  },
  {
    id: 'createdAt',
    accessorKey: 'createdAt',
    header: i18n.t('createdAt', { ns: 'common' }),
    cell: (props) => formatOptionalDate(props.getValue() as Date)
  },
  {
    id: 'userCount',
    accessorKey: 'userCount',
    header: i18n.t('numberOfUsers', { ns: 'common' }),
    cell: (props) => (
      <div className='flex justify-end md:justify-start'>{props.getValue() as string}</div>
    )
  },
  {
    id: 'enabled',
    header: i18n.t('status', { ns: 'common' }),
    accessorKey: 'enabled',
    cell: (props) => <Tag value={props.getValue() ? 'Active' : 'Inactive'} />
  }
];

export const mapOrganizationsToTableData = (organizations: Organization[]): TableData[] => {
  return organizations.map((organization) => ({
    ...organization,
    userCount: Array.isArray(organization.userIds) ? organization.userIds.length : 0
  }));
};
